import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axiosInstance";

export const sipApi = createAsyncThunk(
  "sip",
  async ({ status,startDate = null, endDate = null }) => {
    const params = {};
    if(status) params.status=status
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;
    const response = await axiosInstance.get("/sip", { params });
    return response.data;
  }
);

const sipSlice = createSlice({
  name: "sip",
  initialState: {
    sip: [],
    errors: [],
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(sipApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(sipApi.fulfilled, (state, action) => {
        state.sip = action.payload;
        state.loading = false;
      })
      .addCase(sipApi.rejected, (state, action) => {
        state.errors.push(action.error.message);
        state.loading = false;
      });
  },
});

export default sipSlice.reducer;
